export default __webpack_public_path__ + "static/media/60.1b4d1f86.jpeg";